module.exports = __webpack_public_path__ + "img/mini-responsive-samii.cf623f75.png";